(function () {
  'use strict';

  /**
   * Reads buy-more tier config from the cart page JSON blob.
   * @returns {object|null}
   */
  function getConfig() {
    var configEl = document.querySelector('[data-effilo-progress-config]');
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Returns fill width % for the current item count.
   * @param {object} config
   * @param {number} itemCount
   * @returns {number}
   */
  function getFillPercent(config, itemCount) {
    var pos = config.visualPositions || { 1: 8, 2: 50, 3: 92 };
    var t1 = config.tier1Qty || 1;
    var t2 = config.tier2Qty || 2;
    var t3 = config.tier3Qty || 3;

    if (itemCount >= t3) return pos[3];
    if (itemCount >= t2) return pos[2];
    if (itemCount >= t1) return pos[1];
    return 0;
  }

  /**
   * Builds urgency/CTA state for the next unreached tier.
   * @param {object} config
   * @param {number} itemCount
   * @returns {{ complete: boolean, needed: number, teaser: string }|null}
   */
  function getNextState(config, itemCount) {
    var t2 = config.tier2Qty || 2;
    var t3 = config.tier3Qty || 3;

    if (itemCount >= t3) {
      return { complete: true, needed: 0, teaser: '' };
    }
    if (itemCount >= t2) {
      return {
        complete: false,
        needed: Math.max(1, t3 - itemCount),
        teaser: config.tier3Teaser || '₹600'
      };
    }
    return {
      complete: false,
      needed: Math.max(1, t2 - itemCount),
      teaser: config.tier2Teaser || '₹500'
    };
  }

  /**
   * Toggles complete/pending classes on a milestone dot + meta block.
   * @param {Element} root
   * @param {number} index
   * @param {boolean} complete
   * @returns {void}
   */
  function updateMilestone(root, index, complete) {
    var dot = root.querySelector('[data-effilo-progress-dot="' + index + '"]');
    var meta = root.querySelector('[data-effilo-progress-meta="' + index + '"]');

    if (dot) {
      dot.classList.toggle('effilo-cart-progress__dot--complete', complete);
      dot.classList.toggle('effilo-cart-progress__dot--pending', !complete);
    }
    if (meta) {
      meta.classList.toggle('effilo-cart-progress__meta--pending', !complete);
    }
  }

  /**
   * Ensures the Add Shirt hint text exists when needed and returns it.
   * @param {Element} root
   * @returns {HTMLParagraphElement|null}
   */
  function ensureCta(root) {
    var cta = root.querySelector('[data-effilo-progress-cta]');
    if (cta) return cta;

    cta = document.createElement('p');
    cta.className = 'effilo-cart-progress__cta';
    cta.setAttribute('data-effilo-progress-cta', '');
    cta.innerHTML = 'Add <span data-effilo-progress-cta-count></span> Shirt';
    root.appendChild(cta);
    return cta;
  }

  /**
   * Re-renders progress UI from live cart item count.
   * @param {Element} root
   * @param {object} config
   * @param {number} itemCount
   * @returns {void}
   */
  function renderProgress(root, config, itemCount) {
    if (!root || !config) return;

    var fill = root.querySelector('[data-effilo-progress-fill]');
    if (fill) fill.style.width = getFillPercent(config, itemCount) + '%';

    updateMilestone(root, 1, itemCount >= (config.tier1Qty || 1));
    updateMilestone(root, 2, itemCount >= (config.tier2Qty || 2));
    updateMilestone(root, 3, itemCount >= (config.tier3Qty || 3));

    var state = getNextState(config, itemCount);
    var messageEl = root.querySelector('[data-effilo-progress-message]');
    var cta = root.querySelector('[data-effilo-progress-cta]');

    if (state.complete) {
      if (messageEl) messageEl.textContent = 'You unlocked max savings';
      if (cta) cta.remove();
    } else if (messageEl) {
      var shirtWord = state.needed === 1 ? 'shirt' : 'shirts';
      messageEl.innerHTML =
        'You\'re <span data-effilo-progress-needed>' +
        state.needed +
        '</span> ' +
        shirtWord +
        ' away from saving <span class="effilo-cart-progress__amount" data-effilo-progress-teaser>' +
        state.teaser +
        '</span>';

      cta = ensureCta(root);
      var word = state.needed === 1 ? 'Shirt' : 'Shirts';
      cta.innerHTML =
        'Add <span data-effilo-progress-cta-count>' + state.needed + '</span> ' + word;
    }

    root.dataset.cartItemCount = String(itemCount);
  }

  /**
   * Applies progress UI to every progress root using a known item count.
   * @param {number} itemCount
   * @returns {void}
   */
  function applyProgressCount(itemCount) {
    var config = getConfig();
    if (!config) return;
    document.querySelectorAll('[data-effilo-cart-progress]').forEach(function (root) {
      renderProgress(root, config, itemCount);
    });
  }

  /**
   * Fetches /cart.js and syncs every progress root on the page.
   * @returns {Promise<void>}
   */
  function syncProgress() {
    var config = getConfig();
    if (!config) return Promise.resolve();

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        applyProgressCount(cart.item_count || 0);
      })
      .catch(function (error) {
        console.error('Effilo cart progress sync failed', error);
      });
  }

  /**
   * Runs progress sync after Alpine morph so the re-rendered bar gets fresh state.
   * @param {Event} event
   * @returns {void}
   */
  function onCartChange(event) {
    var response = event && event.detail && event.detail.response;
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        if (response && response.item_count != null) {
          applyProgressCount(response.item_count);
        } else {
          syncProgress();
        }
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProgress);
  } else {
    syncProgress();
  }

  window.addEventListener('shapes:cart:afteradditem', onCartChange);
  window.addEventListener('shapes:cart:cartqtychange', onCartChange);
  window.addEventListener('shapes:cart:update', onCartChange);
})();
